import React, { useState, useEffect } from 'react';
import { Navigate , useNavigate } from 'react-router-dom';
import axios from 'axios';

import { API_BASE_URL } from "../Variables";
import { disconnectSocket } from "../services/Socket";

/**
 * Use this component to protect routes that require authentication.
 * @param {*} children - The component to render if the user is authenticated
 * @returns - The component to render if the user is authenticated, or a redirect to the login page if the user is not authenticated
 */
const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const navigate = useNavigate();

  // Check if the user is authenticated
  useEffect(() => {
    let isCancelled = false; // Flag to prevent setting state if component is unmounted

    const checkToken = async () => {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      try {
        const response = await axios.post(`${API_BASE_URL}/auth/verify-token`, {}, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!isCancelled) {
          setIsAuthenticated(response.data.valid);
          if (!response.data.valid) {
            localStorage.removeItem('token');
          }
        }

      } catch (error) {
        console.error('Error verifying token:', error);
        if (!isCancelled) {
          setIsAuthenticated(false);
          localStorage.removeItem('token');
          disconnectSocket();
          navigate('/login');
        }

      }
    };

    checkToken();

    // Cleanup function to set isCancelled to true if component unmounts
    return () => {
      isCancelled = true;
    };
  }, [navigate]);

  if (isAuthenticated === null) {
    return <div>Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;

